import React, { useRef } from 'react';
import { FAQ } from '@yme/assets/icons';
import { useCheckHeightIsBigger } from '@yme/hooks/index';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { noop } from '@yme/utils/common';
import { NavigationStyled, HeadingLevel4Styled, NavigationMiniButtonStyled, SVGFAQIconStyled, FAQContainerStyled, FAQTextStyled, } from './styled';
export function Navigation({ isRightToLeft, pageNotFoundTitle, needAssistanceTitle, }) {
    const h4Ref = useRef(null);
    const isMarginTop = useCheckHeightIsBigger(h4Ref, 30);
    return (React.createElement(NavigationStyled, null,
        React.createElement(FlexWrapper, null,
            React.createElement(HeadingLevel4Styled, { isMarginTop: isMarginTop, ref: h4Ref, color: colorCoreWhite1000, alignSelf: "center" }, pageNotFoundTitle)),
        React.createElement(FlexWrapper, null,
            React.createElement(NavigationMiniButtonStyled, { onClick: noop, isRightToLeft: isRightToLeft, contentColor: colorCoreWhite1000, isFirstIcon: true },
                React.createElement(FAQContainerStyled, { isRightToLeft: isRightToLeft },
                    React.createElement(SVGFAQIconStyled, { type: FAQ, isRightToLeft: isRightToLeft }),
                    React.createElement(FAQTextStyled, null, needAssistanceTitle))))));
}
Navigation.displayName = 'Navigation_Component';
